import React, { useCallback, useContext, useState,  } from 'react';
import { Button, Notifier, notify, PageLoader } from '@scholastic/volume-react';

import { SearchableDropdownValue } from '../Home/Home.dataparser';
import { StoreContext } from '../../state/store';
import { ProductsCheckbox } from '../../utils/dataparsers.util';
import { downloadGroupLevelReports } from '../../state/CounterReports.api';

import GroupProductSelector from './GroupProductSelector/GroupProductSelector';
import GroupDateSelector from './GroupDateSelector/GroupDateSelector';
import './GroupLevelReports.scss';

const GroupLevelReports = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { state } = useContext(StoreContext);
  const customer = state.customerInfo;

  const [dateRange, setDateRange] = useState<{
    from: SearchableDropdownValue;
    to: SearchableDropdownValue;
  } | null>(null);

  const [products, setProducts] = useState<Array<ProductsCheckbox>>([]);

  const groupProductsCallback = useCallback((products: Array<ProductsCheckbox> | null) => {
    if (products) {
      setProducts(products);
    }
  }, [setProducts])

  const dateRangeCallback = (from: SearchableDropdownValue, to: SearchableDropdownValue) => {
    setDateRange({ from: from, to: to });
  };

  const sendRequest = () => {
    if (
      dateRange?.from &&
      dateRange?.to &&
      new Date(dateRange?.from.value) <= new Date(dateRange?.to.value)
    ) {
      const request: any = {
        customerid: customer.result.customerid,
        pcodesgood: true,
        outformat: 'midtier',
        reporttype: 'midtier',
        startdate: dateRange?.from.value,
        enddate: dateRange?.to.value,
      };

      products.map((product: ProductsCheckbox) => {
        if (product.checked) {
          request[`show${product.value}`] = 'yes';
        }

        return {};
      });

      downloadGroupLevelReports(request, hideLoading);
    } else {
      notify.warning('Please provide correct from and to date');
    }
  };

  const hideLoading = () => {
    setIsLoading(false);
  }

  return (
    <div className="stats-glr">

      {isLoading && (
        <div>
          <PageLoader color={'dark'} size={'large'} type={'border'} />
        </div>
      )}

      <Notifier
        autoClose={5000}
        closeButton={false}
        closeOnClick={false}
        draggable
        draggablePercent={50}
        limit={1}
        newestOnTop
        pauseOnFocusLoss
        pauseOnHover
        position="top-center"
        role="alert"
      />
      <div className="stats-glr__section">
        <GroupProductSelector callback={groupProductsCallback} />
      </div>
      <div className="stats-glr__section stats-glr__section--small">
        <GroupDateSelector callback={dateRangeCallback} />

        <Button disabled={isLoading} color="info" className="float-right mt-2" onClick={sendRequest}>
          Create Report
        </Button>
      </div>
    </div>
  );
};

export default GroupLevelReports;
